'use es6';

export default {
  COMPANY: 'company',
  CUSTOMER: 'customer'
};